<template>
  <button class="border border-gray-600 bg-gray-200 hover:bg-gray-300 rounded-sm flex items-center justify-center p-1">
    <Icon :icon="icon" class="w-4 h-4" />
  </button>
</template>

<script lang="ts" setup>
import { type Component, type PropType } from 'vue';
import Icon from './Icon.vue';

defineProps({
  icon: {
    type: Object as PropType<Component>,
    required: true,
  },
});
</script>
